import angular from "angular";

angular
	.module('app')
	.component('courseLessonsAutomatizationPageRestricted', {
		template: require('./course-lessons-automatization-page-restricted.html'),
        controller: ['$http', '$uibModal', 'Notifier', controller],
        bindings: {
            course: '<',
            chapters: '<',
        }
    });

function controller($http, $uibModal, Notifier) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
        //
    };
}
